import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Common from '../services/common.js';
import Basic from '../Components/Basic/Basic';
import Toast from '../Components/Toast/Toast';

const UploadTransactionReceipt = () => {
  const [errors] = useState([]);
  const [docFile, setDocFile] = useState(null);
  const [token, setToken] = useState('');
  const [investor, setInvestor] = useState('');
  const [linkCode, setLinkCode] = useState('');
  const [docName] = useState('Transaction Receipt');
  const [docFileError, setDocFileError] = useState('');
  const [form, setForm] = useState({
    doc_file_name: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const toastRef = useRef();
  const submitBtnRef = useRef();
  const errorBlockRef = useRef();
  
  const STORAGE_KEY = "caprock-local";
  const session = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");

  useEffect(() => {
    // Get URL parameters
    const urlParams = Object.fromEntries(searchParams.entries());
    setToken(urlParams.token || '');
    setInvestor(urlParams.profile || '');
    setLinkCode(urlParams.ltoken || '');
    
    // Check token validity
    tokenAlert();
    
    // Get link details if link code exists
    if (urlParams.ltoken && urlParams.ltoken !== '') {
      getLinkDetails(urlParams.ltoken);
    }
    
    // Set document title
    document.title = `${docName} || Caprock Merchant Platform`;
  }, [searchParams, docName]);

  const tokenAlert = () => {
    if (!token || token === '') {
      // window.location.href = 'https://caprock.com.au';
    }
  };

  const getLinkDetails = async (linkCode) => {
    try {
      const response = await Common.get_link_details(linkCode);
      console.log(response.data);
      
      if (response.data && response.data.success !== 200) {
        alert('Link expired!');
        window.location.href = "https://caprock.com.au";
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchFile = (event) => {
    const file = event.target.files[0];
    if (event.target.name === 'doc_file') {
      setDocFile(file);
      setForm(prev => ({ ...prev, doc_file_name: file.name }));
      setDocFileError('');
    }
  };

  const submitForm = async (e) => {
    if (!docFile) {
      setDocFileError('Please select valid document for upload.');
      toastRef.current?.miralToast(
        'Warning',
        'Please select valid document for upload.',
        '',
        false
      );
      return false;
    }

    setIsSubmitting(true);
    const submitBtn = submitBtnRef.current;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Processing ... ';
    }

    const formData = new FormData();
    formData.append('doc_file', docFile);
    formData.append('token', token);
    formData.append('doc_name', 'Transaction Receipt');
    formData.append('req_id', investor);
    formData.append('link_code', linkCode);

    try {
      const url = Common.base_url() + 'upload-transaction-receipt';
      
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      });

      const data = await response.json();

      if (data.success === 200) {
        toastRef.current?.miralToast(
          'Success',
          data.message,
          '',
          false
        );
        
        setTimeout(() => {
          navigate('/sign-in');
        }, 2500);
      } else {
        toastRef.current?.miralToast(
          'Warning',
          data.message,
          '',
          false
        );
      }
    } catch (error) {
      console.error('Upload error:', error);
      toastRef.current?.miralToast(
        'Error',
        'An error occurred during upload',
        '',
        false
      );
    } finally {
      setIsSubmitting(false);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Upload Now';
      }
    }
  };

  const removeErr = (event) => {
    const errorElement = document.querySelector('.' + event.currentTarget.id + 'err');
    if (errorElement) {
      errorElement.remove();
    }
  };

  const openModal = (id) => {
    setShowModal(true);
  };

  const closeModal = (id) => {
    setShowModal(false);
  };

  return (
    <>
      <Basic />
      <section className="bg-white min-h-screen">
        <div className="container mx-auto px-4 py-8 flex justify-center">
          <form method="POST" action="/" className="w-full max-w-4xl">
            <div className="space-y-6">
              <div className="w-full">
                <div className="bg-white rounded-lg shadow-lg p-8">
                  <div className="py-4">
                    <div className="w-full">
                      <div className="w-full">
                        <p className="text-3xl font-bold tracking-wide leading-normal">
                          Upload your {docName} !
                        </p>
                      </div>
                    </div>
                    <div className="mt-4 mb-0">
                      <input
                        onChange={fetchFile}
                        id="doc_file"
                        type="file"
                        className="w-full bg-transparent border-b border-gray-400 focus:border-blue-500 focus:outline-none py-2 px-0"
                        name="doc_file"
                        required
                      />
                      <small className="text-red-600 text-sm ml-2">{docFileError}</small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full">
                <div className="flex justify-center px-1 mb-4 mt-0">
                  <div className="w-full px-1">
                    <button
                      ref={submitBtnRef}
                      id="subBtn"
                      type="button"
                      onClick={submitForm}
                      className="w-full bg-green-600 hover:bg-green-700 disabled:bg-green-400 disabled:cursor-not-allowed text-white font-medium py-3 px-6 rounded-lg text-lg transition-colors duration-200 mt-3 disabled:opacity-60"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Processing ... ' : 'Upload Now'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>

      {/* Modal */}
      {showModal && (
        <div
          className="fixed inset-0 z-50 overflow-y-auto"
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="flex min-h-screen items-center justify-center p-4">
            <div className="fixed inset-0 bg-black bg-opacity-50" onClick={() => closeModal('exampleModal')}></div>
            <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full">
              <div className="flex items-center justify-between p-6 border-b">
                <h5 className="text-lg font-semibold text-gray-900" id="exampleModalLabel">Please fix this</h5>
                <button
                  type="button"
                  onClick={() => closeModal('exampleModal')}
                  className="text-gray-400 hover:text-gray-600 text-xl font-bold"
                >
                  ×
                </button>
              </div>
              <div className="p-6">
                {errors.length > 0 && (
                  <div ref={errorBlockRef} id="errorBlock" className="space-y-2">
                    {errors.map((error, key) => (
                      <div key={key} className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
                        {error}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <Toast ref={toastRef} />
    </>
  );
};

export default UploadTransactionReceipt;
